import React, {Component} from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleInput from "../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleToggleButton from "../../../modules/SimpleToggleButton";
import * as R from "ramda";
import {Level, Status} from "../../common/Constants";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleDDL from "../../../modules/SimpleDDL";
import withFormGroup from "../../../modules/commons/withFormGroup";

class MasterHirarkiModifying extends Component {
    handleSubmit = (e) => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        console.log("this.props: ", this.props);
        return (
            <>
                <SimpleModal
                    title="Detail Hirarki"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                                <SimpleInput
                                    id="input_text_nama_role"
                                    name="roleName"
                                    label="Nama Role"
                                    mandatory
                                    errorMessage={this.props.errors.roleName}
                                    value={this.props.controls.roleName.value}
                                    onChange={({ target }) =>
                                        this.props.setValue(target.name, target.value)
                                    }
                                />
                                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                                    <SimpleDDL
                                        id="select_options_level_ahass"
                                        name="ahasLine"
                                        label="Ahass Line"
                                        containerclassname="margin-botton-5px width width-full"
                                        box="search"
                                        isSearchable={true}
                                        isClearable
                                        options={Level}
                                        mandatory
                                        errorMessage={this.props.errors.ahasLine}
                                        value={this.props.controls.ahasLine.value}
                                        onChange={(value, { name }) =>
                                            this.props.setValue(name, value)
                                        }
                                    />
                                    <SimpleDDL
                                        id="select_options_level_mkt"
                                        name="mktLine"
                                        label="Mkt Line"
                                        mandatory
                                        containerclassname="margin-botton-5px width width-full"
                                        box="search"
                                        isSearchable={true}
                                        isClearable
                                        options={Level}
                                        errorMessage={this.props.errors.mktLine}
                                        value={this.props.controls.mktLine.value}
                                        onChange={(value, { name }) =>
                                            this.props.setValue(name, value)
                                        }
                                    />
                                    <SimpleDDL
                                        id="select_options_level_admin"
                                        name="adminLine"
                                        label="Admin Line"
                                        mandatory
                                        containerclassname="margin-botton-5px width width-full"
                                        box="search"
                                        isSearchable={true}
                                        isClearable
                                        options={Level}
                                        errorMessage={this.props.errors.adminLine}
                                        value={this.props.controls.adminLine.value}
                                        onChange={(value, { name }) =>
                                            this.props.setValue(name, value)
                                        }
                                    />
                                </FlexView>
                                <SimpleToggleButton
                                    id="input_toggle_status"
                                    label="Status"
                                    value={R.equals(this.props.controls.status.value, Status.ACTIVE)}
                                    onToggle={(value) =>
                                        this.props.setValue(
                                            "status",
                                            !value ? Status.ACTIVE : Status.INACTIVE
                                        )
                                    }
                                />
                                <div style={{ textAlign: "right" }}>
                                    <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                                    <SimpleButton
                                        type="button"
                                        secondary
                                        onClick={this.props.reset}
                                    >
                                        Clear
                                    </SimpleButton>
                                </div>
                        </ModalContainer>
                    }
                />
            </>
        );
    }
}

export default withFormGroup(MasterHirarkiModifying);

class ModifyingLevelDDL extends Component {
    render() {
        return (
            <FlexView column hAlignContent="center" style={{ flex: 1 }}>
                <SimpleDDL
                    containerclassname="margin-botton-5px width width-full"
                    box="search"
                    isSearchable={true}
                    isClearable
                    options={Level}
                    {...this.props}
                />
                <div className="txt-site txt-11 txt-main txt-bold">
                    <h4>{this.props.text}</h4>
                </div>
            </FlexView>
        );
    }
}